import React from "react";

function Unauthorized() {
  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1 style={{ color: "red" }}>Unauthorized Access</h1>
      <p>You do not have the necessary permissions to view this page.</p>
      <p>Please log in to continue or contact the administrator if you believe this is an error.</p>
    </div>
  );
}

export default Unauthorized;
